import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-2 w-2 rounded-full bg-green-400"
}
const _hoisted_2 = {
  key: 1,
  class: "h-2 w-2 rounded-full bg-yellow-400"
}
const _hoisted_3 = {
  key: 2,
  class: "h-2 w-2 rounded-full bg-red-400"
}
const _hoisted_4 = {
  key: 3,
  class: "text-md text-gray-900"
}
const _hoisted_5 = {
  key: 0,
  class: "text-gray-500"
}

import { computed } from "vue"
import { EmailAddress } from "@/shared/models/email"
import { formatters } from "@/shared/utils/dateUtils"

// Define props for the email object

export default /*#__PURE__*/_defineComponent({
  __name: 'EmailStatus',
  props: {
    email: {},
    showLabel: { type: Boolean },
    enableTooltip: { type: Boolean }
  },
  setup(__props: any) {

// Email status indicator component
// Shows engagement score and last bounce tooltip for an email
const props = __props

/**
 * Computes the tooltip text for the last bounce date.
 * Returns a formatted string or fallback if not available.
 */
const tooltipMessages = computed<string[]>(() => {
    const messages: string[] = []
    try {
        if (props.email.lastHardBounce) {
            messages.push(
                `Last hard bounce: ${formatters.formatHumanReadableDate(new Date(props.email.lastHardBounce), true)}`
            )
        }
        if (props.email.lastSoftBounce) {
            messages.push(
                `Last soft bounce: ${formatters.formatHumanReadableDate(new Date(props.email.lastSoftBounce), true)}`
            )
        }
        if (props.email.optOut) {
            messages.push(`Opt out: ${formatters.formatHumanReadableDate(new Date(props.email.optOut), true)}`)
        }
        if (props.email.spamComplaint) {
            messages.push(
                `Spam complaint: ${formatters.formatHumanReadableDate(new Date(props.email.spamComplaint), true)}`
            )
        }
        if (messages.length > 0) {
            return messages
        }
        if (
            !props.email.lastHardBounce &&
            !props.email.lastSoftBounce &&
            !props.email.optOut &&
            !props.email.spamComplaint &&
            props.email.engagementScore === 2
        ) {
            return ["Unverified"]
        }
        return ["No issue"]
    } catch (error) {
        return ["No issue"]
    }
})

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['flex items-center space-x-2', !_ctx.showLabel && 'cursor-help'])
  }, [
    (_ctx.email.engagementScore && _ctx.email.engagementScore > 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_ctx.email.engagementScore && _ctx.email.engagementScore <= 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
    (_ctx.showLabel)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(tooltipMessages.value[0]), 1),
          (tooltipMessages.value.length > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " +" + _toDisplayString(tooltipMessages.value.length - 1), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [
      _directive_tooltip,
      tooltipMessages.value.length > 0 ? tooltipMessages.value.join('\n') : null,
      void 0,
      { top: true }
    ]
  ])
}
}

})